import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { toastr } from 'react-redux-toastr';
import { hideCicAlertModal } from 'actions/monitoring/getCicAlertModal';

import { getCicAlertCounts } from './getCicAlertCounts';

export const SAVE_CIC_ALERT_REVIEW_STATE_REQUEST = 'SAVE_CIC_ALERT_REVIEW_STATE_REQUEST';
export const SAVE_CIC_ALERT_REVIEW_STATE_SUCCESS = 'SAVE_CIC_ALERT_REVIEW_STATE_SUCCESS';
export const SAVE_CIC_ALERT_REVIEW_STATE_FAILURE = 'SAVE_CIC_ALERT_REVIEW_STATE_FAILURE';

function requestSaveCicAlertReviewState() {
  return {
    type: SAVE_CIC_ALERT_REVIEW_STATE_REQUEST,
    isSavingCicReviewState: true,
  };
}

function receiveSaveCicAlertReviewState(cicReviewState) {
  return {
    type: SAVE_CIC_ALERT_REVIEW_STATE_SUCCESS,
    isSavingCicReviewState: false,
    cicReviewState,
    cicReviewStateError: null
  };
}

function rejectSaveCicAlertReviewState(cicReviewStateError) {
  return {
    type: SAVE_CIC_ALERT_REVIEW_STATE_FAILURE,
    isSavingCicReviewState: false,
    cicReviewStateError
  };
}

export function saveCicAlertReviewState(id, values) {
  const formData = new FormData();
  formData.append('reviewerComment', values.draftComments);
  formData.append('actionId', values.actionId);
  if (values.assignToUser) {
    formData.append('assignToUser', values.assignToUser.id);
  }
  if (values.isCic != null) {
    formData.append('isCic', values.isCic);
  }
  if (values.hasCuringDocs != null) {
    formData.append('hasCuringDocs', values.hasCuringDocs);
  }
  if (values.curingDocs) {
    formData.append('curingDocs', JSON.stringify(values.curingDocs));
  }
  if (values.changes) {
    formData.append('changes', JSON.stringify(values.changes));
  }

  return (dispatch) => {
    dispatch(requestSaveCicAlertReviewState());

    const promise = () => ApiService
      .saveCicReviewState(id, formData)
      .then((response) => {
        dispatch(receiveSaveCicAlertReviewState(response.data));
        dispatch(getCicAlertCounts());
        if (values.actionId || values.assignToUser) {
          // Redirect back to alert table if a workflow action has been submitted
          dispatch(hideCicAlertModal(true));
        } else {
          toastr.success('CiC Alert Saved', 'The CiC Alert has been saved successfully');
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSaveCicAlertReviewState, true));
        }
      });
    return promise();
  };
}
